const GameCountAndPeriod = ({ data }) => {
    return (
        <div>
      <div className="game-status">
        <div className="status-box">
          <span className="label">Versuch</span>
          <span className="value">{data.gamecount}</span>
        </div>
        <div className="status-box">
          <span className="label">Periode</span>
          <span className="value">{data.aktp}</span>
        </div>
      </div>
      </div>
    );
  };
  
  
  export default GameCountAndPeriod